angular.module('tf.controllers')

    .controller('LoginController', ['$scope', '$rootScope', 'AuthService','Session','$state','$timeout', '$stateParams','AuthAlertService','$cookies','NotificationService', '$http','RecaptchaService',
            function ($scope, $rootScope, AuthService,Session, $state, $timeout, $stateParams, AuthAlertService, $cookies, NotificationService, $http, RecaptchaService) {

                $scope.disableButton = false;
                $scope.requireSSO = false;
                $scope.isLoggedIn = AuthService.isAuthenticated;
                $scope.credentials = {
                    email: '',
                    password: ''
                };
                $scope.referer = $stateParams.referer;
                $scope.state = $state.current.name;

                $scope.login = function (credentials) {
                    if($scope.requireSSO){
                        window.location.href = '/sso?email=' + credentials.email;
                    } else {
                        AuthService.login(credentials);
                    }

                };
                $scope.signup = function (credentials) {
                    AuthService.signup(credentials);
                };
                $scope.register = function (credentials) {
                    AuthService.register(credentials);
                };
                $scope.subscribe = function (credentials){
                    AuthService.subscribe(credentials).then(function(){
                        $scope.subscribed = true;
                    });
                };

                if($state.current.name === 'contact'){
                    RecaptchaService.renderV3('contact-recaptcha');
                    // RecaptchaService.render('contact-recaptcha', function(token){
                    //     $scope.form['g-recaptcha-response'] = token;
                    //     $scope.contact();
                    // });
                }

                $scope.reset = function(credentials){
                    if(credentials.password !== credentials.confirmPassword){
                        return AuthAlertService.alert('Passwords must match', 'danger');
                    }
                    $scope.disableButton = true;
                    AuthService.resetPassword(credentials);
                };

                if($scope.referer && $scope.referer.email){
                    $scope.credentials.email = $scope.referer.email;
                    $scope.credentials.confirmEmail = $scope.credentials.email;
                    $scope.emailPreset = true;
                }

                $scope.$on("login-info", function(event, data){
                    $scope.showAlert(data);
                });
                $scope.$on("login-error", function(event, data){
                    $scope.showAlert(data);
                });
                $scope.$on("signup-error", function(event, data){
                    $scope.showAlert(data);
                });
                $scope.showAlert = function(alert){
                    $timeout(function(){alert.show();},1);
                };

                $scope.resendVerificationEmail = function(){
                    var email = $cookies.get('user_email');
                    if(email){
                        AuthService.resendVerificationEmail(email).then(function () {
                            NotificationService.notify('info-alert', {content: "Please check your email to verify your account"});
                        });
                    }
                };

                if($state.current.name === 'login'){
                    $timeout(function(){$('input[type=email]').focus();},50);
                }

                (function handleInit(){
                    var emailFromCookie = $cookies.get('user_email');
                    if(emailFromCookie && $state.params.tfref){
                        $scope.credentials.email = emailFromCookie;
                        $scope.credentials.confirmEmail = emailFromCookie;
                        $scope.emailPreset = true;
                    }
                })();

                $scope.contact = function(){
                    RecaptchaService.execute('contact').then(function(token){
                        $scope.form['g-recaptcha-response'] = token;
                        $scope.disableContact = true;
                        $scope.contactButtonText = 'Thank you for reaching out, we will get back to you ASAP';
                        $http.post('/contact', $scope.form);
                    });
                    // $scope.disableContact = true;
                    // $scope.contactButtonText = 'Thank you for reaching out, we will get back to you ASAP';
                    // $http.post('/contact', $scope.form);
                };

                if($scope.state === 'home') {
                    $('.testimonials-carousel').slick({
                        autoplay: true,
                        autoplaySpeed: 5000,
                        arrows: false,
                        dots: true
                    });
                }

    }])
;
